import Header from './Header'
export default Header



/** WEBPACK FOOTER **
 ** ./src/Header/index.js
 **/